import type {Rec} from 'src/typings';
import './kp-carousel.less';
import templatePath from './kp-carousel.tpl.ftl';
import KpCover from '../../../features/record/kp-cover/KpCover.svelte';
import KpCustomParagraph from 'shared/value-editors/internal/editors/search-or-edit/templates/KpCustomParagraph.svelte';
import type {SearchService} from '../../../features/search/search.service';

class KpCarouselComponentController {
    kpCoverComponent = KpCover;
    kpCustomParagraph = KpCustomParagraph;

    public searchQuery: string;
    public orderBy?: string;
    public maxCount?: string;
    public cache?: string;
    public items: Rec[];
    public settings: { nextArrow: string; dots: boolean; prevArrow: string; slidesToShow: number; autoplay: boolean; autoplaySpeed: number };

    /*@ngInject*/
    constructor(private searchService: SearchService) {
        this.searchService = searchService;
        this.items = [];

        this.settings = {
            dots: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 10000,
            prevArrow: '#btn-carousel-prev',
            nextArrow: '#btn-carousel-next'
        }
    }

    $onInit() {
        const searchParams: Record<string, any> = {
            qt: this.searchQuery,
            pageSize: this.maxCount ?? 5,
            exports: 'portaroRecordNewsParagraph',
            cache: this.cache ?? 'longterm'
        };

        if(this.orderBy) {
            searchParams.sorting = this.orderBy;
        }

        this.searchService
            .search<Rec>(searchParams)
            .then((result) => {
                this.items = result.result.content;
            });
    }
}

/**
 * @ngdoc component
 * @name kpCarousel
 * @module portaro.components
 *
 * @param {string} searchQuery Search query
 * @param {string=} orderBy Sorting field name. `-` before name switches to descending sorting. e.g.`-REZS_DATVYT`
 * @param {number=} maxCount Maximum results count. Default is `5`.
 * @param {string=} cache Specify server cache mode
 *
 * @requires service:searchService
 *
 * @description
 * Component gets records by {@link service:searchService searchService} and renders results from `portaroRecordNewsParagraph` export.
 *
 * @example
 * ```html
 *      <kp-carousel search-query='{"and": [{"field": "fond", "in": {"value": [1]}}, {"field": "recordCreationDate", "between": {"from": 2017, "to": null}}]}' order-by="REZS_DATVYT" max-count="10"></kp-carousel>
 * ```
 */

export default class KpCarouselComponent {
    static componentName = 'kpCarousel';

    templateUrl = templatePath;
    bindings = {
        searchQuery: '@',
        orderBy: '@?',
        maxCount: '@?',
        cache: '@?'
    };
    controller = KpCarouselComponentController;
}